import { useCallback } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setSafety } from "@/domains/account/slice";

export default function useAccountSettings() {
  const dispatch = useAppDispatch();
  const getAccountSettings = useCallback(async () => {
    const response = await AccountMpProvider.getAccountSettings();

    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setSafety(response.data.account));
    }
  }, []);

  return {
    getAccountSettings,
  };
}
